var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "dialog-big oow-modal",
      attrs: {
        id: "oow-modal",
        visible: _vm.visible,
        "close-on-click-modal": false,
        "custom-class": "custom-dialog-class",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "el-dialog__title",
          attrs: { slot: "title" },
          slot: "title",
        },
        [
          _c("h2", [
            _vm._v(
              " " + _vm._s(_vm.action) + " Eligibility Restriction Detected"
            ),
          ]),
          _vm._v(" "),
          _c("p", [_vm._v(" One or more restrictions prevent this action:")]),
        ]
      ),
      _vm._v(" "),
      _c("device-restriction-details", {
        staticClass: "device-restriction-details",
        attrs: {
          "warranty-ends-at": _vm.warrantyEndsAt,
          "oow-reason": _vm.oowReason,
          restrictions: _vm.restrictions,
        },
      }),
      _vm._v(" "),
      _vm.bypassAllowed
        ? _c(
            "div",
            { staticClass: "bypass-warranty" },
            [
              _c("p", [_c("strong", [_vm._v("Bypass Restriction")])]),
              _vm._v(" "),
              _c(
                "el-select",
                {
                  attrs: {
                    placeholder: "Select reason for bypass...",
                    name: "bypass_reason",
                  },
                  model: {
                    value: _vm.selectedBypassReason,
                    callback: function ($$v) {
                      _vm.selectedBypassReason = $$v
                    },
                    expression: "selectedBypassReason",
                  },
                },
                _vm._l(_vm.reasons, function (reason) {
                  return _c(
                    "el-option",
                    { key: reason, attrs: { label: reason, value: reason } },
                    [
                      _c("span", { staticStyle: { float: "left" } }, [
                        _vm._v(_vm._s(reason)),
                      ]),
                    ]
                  )
                }),
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "footer" },
        [
          _vm.bypassAllowed && _vm.selectedBypassReason
            ? _c(
                "el-button",
                {
                  ref: "bypassButton",
                  staticClass: "button-confirm-replacement",
                  attrs: {
                    type: "primary",
                    disabled: !_vm.selectedBypassReason,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.bypass()
                    },
                  },
                },
                [_vm._v("\n      Bypass Warranty Requirement\n    ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-button",
            {
              ref: "closeButton",
              attrs: { type: "default" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.bypassAllowed ? "Cancel" : "Close") +
                  "\n    "
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }